import { phoneNumberValidator } from '@shared/libs/phone-validator';
import type { FormData, Guests } from '../../model/types';
import { COMPONENT_TYPE_GUEST } from '../../model/consts';

export const prefillRegistrationGuest = (
  form: FormData | undefined,
  participant: Record<string, string | null> | null | undefined,
  nameLocked: boolean
): FormData | undefined => {
  if (!form || !participant || !nameLocked) return form;
  const result = structuredClone(form);
  for (const component of result.components) {
    if (component.type !== COMPONENT_TYPE_GUEST) continue;
    const guests = component.properties as unknown as Guests;
    if (!guests.mainGuest) continue;
    for (const [dbField, placeholder] of [
      ['lastName', 'Фамилия'],
      ['firstName', 'Имя'],
    ]) {
      let field = guests.mainGuest.FIO.find((item) => item.dbField === dbField);
      if (!field) {
        field = { instanceId: `personal-${dbField}`, dbField, placeholder, label: '', value: '' };
        guests.mainGuest.FIO.push(field);
      }
      field.value = participant[dbField] ?? '';
      field.readOnly = Boolean(field.value.trim());
    }
    for (const field of guests.mainGuest.additionalFields) {
      if (['email', 'phone'].includes(field.dbField) && !field.value) {
        const value = participant[field.dbField] ?? '';
        field.value = field.dbField === 'phone' ? phoneNumberValidator(value) : value;
      }
    }
  }
  return result;
};
